import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 12h4","key":"svg-0"}],["path",{"d":"M3 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M7 8v8","key":"svg-2"}],["path",{"d":"M19 10v4","key":"svg-3"}],["path",{"d":"M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1","key":"svg-4"}]]

const IconSignal4gPlus = createReactComponent('outline', 'signal-4g-plus', 'Signal4gPlus', __iconNode);

export default IconSignal4gPlus;